import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '$shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedBatchModule } from '../../shared-batch';
import { AddressesModule } from '../addresses';
import { BatchesRoutingModule } from './batches-routing.module';
import { BatchesComponent } from './batches.component';
import {
  BatchMailingFormComponent,
  FiltersComponent,
  ServiceUnavailableBannerComponent,
} from './components';
import { AddRecipientComponent } from './components/add-recipient/add-recipient.component';
import { CustomControlErrorComponent } from './components/custom-control-error/custom-control-error.component';
import { SpecialMarksFullComponent } from './components/special-marks-full/special-marks-full.component';
import {
  BatchListComponent,
  EditBatchMailingComponent,
  CreateBatchComponent,
  ViewBatchComponent,
  BatchMailingCardComponent,
  AddBatchMailingComponent,
} from './pages';
import { BatchesParseStorageService, BatchesService } from './services';
import { ViewBatchTabsComponent } from './components/view-batch-tabs/view-batch-tabs.component';
import { ViewBatchDeparturesComponent } from '$modules/personal/modules/batch/features/batches/components/view-batch-departures/view-batch-departures.component';
import { ViewBatchCardComponent } from './components/view-batch-card/view-batch-card.component';
import { EditeBatchDepartureModalComponent } from '$modules/personal/modules/batch/features/batches/modals/edite-batch-departure-modal/edite-batch-departure-modal.component';
import { ViewDepartureAttachmentsComponent } from '$modules/personal/modules/batch/features/batches/pages/view-departure-attachments/view-departure-attachments.component';
import { NavigatePartialReceiptsModalComponent } from './modals/navigate-partial-receipts-modal/navigate-partial-receipts-modal.component';
import { ViewAttachmentsInfoComponent } from '$modules/personal/modules/batch/features/batches/components/view-attachments-info/view-attachments-info.component';
import { AddAttachmentModalComponent } from '$modules/personal/modules/batch/features/batches/modals/add-attachment-modal/add-attachment-modal.component';
import { AttachmentCardComponent } from './components/attachment-card/attachment-card.component';
import { BatchCommitErrorModalComponent } from './modals/batch-commit-error-modal/batch-commit-error-modal.component';

@NgModule({
  declarations: [
    BatchesComponent,
    BatchListComponent,
    CreateBatchComponent,
    FiltersComponent,
    ViewBatchComponent,
    AddRecipientComponent,
    SpecialMarksFullComponent,
    CustomControlErrorComponent,
    ViewBatchTabsComponent,
    ViewBatchDeparturesComponent,
    ViewBatchCardComponent,
    AddBatchMailingComponent,
    EditBatchMailingComponent,
    BatchMailingCardComponent,
    EditeBatchDepartureModalComponent,
    ViewDepartureAttachmentsComponent,
    NavigatePartialReceiptsModalComponent,
    ViewAttachmentsInfoComponent,
    AddAttachmentModalComponent,
    AttachmentCardComponent,
    BatchCommitErrorModalComponent,
    BatchMailingFormComponent,
  ],
  imports: [
    CommonModule,
    BatchesRoutingModule,
    SharedBatchModule,
    SharedModule,
    AddressesModule,
    ModalModule.forRoot(),
    ServiceUnavailableBannerComponent,
  ],
  exports: [SpecialMarksFullComponent],
  providers: [BatchesService, BatchesParseStorageService],
})
export class BatchesModule {}
